import { render } from "./ClearButton.vue?vue&type=template&id=11f3af30&ts=true"
import script from "./ClearButton.vue?vue&type=script&lang=ts"
export * from "./ClearButton.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__